<template>
  <layout title="Компоненты">
    <components-import-modal id="components-import-modal"></components-import-modal>
    <div class="card">
      <div class="card-header bg-white">
        <h4 class="mb-0">
          Компоненты
          <button
              :disabled="! $page.props.can.components.import"
              v-b-modal="'components-import-modal'"
              class="btn btn-outline-success btn-sm float-right">
            <font-awesome-icon icon="file-upload"/>
            Импорт компонентов
          </button>
        </h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col">
            <search-filter v-model="searchQuery" placeholder="Поиск по коду или наименованию" autofocus
                           class="mb-3"></search-filter>
          </div>
        </div>

        <table class="table table-borderless table-sm table-grid">
          <thead>
          <tr>
            <th class="fit">ID</th>
            <th class="fit">Создание</th>
            <th class="fit">Обновление</th>
            <th width="10%">Код</th>
            <th width="65%">Наименования</th>
            <th>Стоимость</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item) in collection.data" :key="item.id">
            <td>
              <small class="text-muted">{{ item.id }}</small>
            </td>
            <td>{{ item.created_at }}</td>
            <td class="fit">{{ item.updated_at }}</td>
            <td>{{ item.code }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.price | currency }}&nbsp;₽</td>
          </tr>
          </tbody>
        </table>
        <nav v-if="collection.meta">
          <ul class="pagination pagination-sm">
            <li v-for="page in Math.ceil(collection.meta.total / collection.meta.per_page)" :key="page" class="page-item"
                :class="page === collection.meta.current_page ? 'active' : ''">
              <Link class="page-link" :href="`${collection.meta.path}?page=${page}${getQueryParams()}`">
                {{ page }}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '~/Layouts/Layout'
import SearchFilter from '~/Components/SearchFilter'
import debounce from 'lodash/debounce'
import ComponentsImportModal from '~/components/Component/ComponentsImportModal'

export default {
  components: {
    ComponentsImportModal,
    Layout,
    SearchFilter
  },
  props: {
    search: String,
    collection: Object
  },
  data () {
    return {
      searchQuery: this.search,
      pagination: this.collection.meta || null
    }
  },
  watch: {
    searchQuery: debounce(function (val, oldVal) {
      if (val === oldVal) {
        return
      }

      this.$inertia.replace(
        this.route('backend.components.index', {
          search: this.searchQuery
        }))
    }, 200)
  },

  methods: {
    getQueryParams () {
      const params = (new URL(document.location)).searchParams
      params.delete('page')

      const queryStr = params.toString()

      return queryStr.length > 0 ? '&' + queryStr : ''
    }
  }
}
</script>
